module.exports = __webpack_public_path__ + "img/logo.ff6b9a87.svg";